import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {
  IBoosterBenchmark, IBoosterClearCacheStats,
  IBoosterState,
  IBoosterStats
} from "../reducers/booster.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getBoosterState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.booster);

export const getWebsiteBoosterStateLoaded = (websiteId: number) => createSelector(getBoosterState,
  (state: IBoosterState): boolean =>
    state.entities[websiteId] && state.entities[websiteId].loaded ? state.entities[websiteId].loaded : false
);

export const getWebsiteBoosterStats = (websiteId: number) => createSelector(getBoosterState,
  (state: IBoosterState): IBoosterStats =>
    state.entities[websiteId] && state.entities[websiteId].stats ? state.entities[websiteId].stats : null
);

export const getWebsiteBoosterCacheStats = (websiteId: number) => createSelector(getBoosterState,
  (state: IBoosterState): IBoosterClearCacheStats =>
    state.entities[websiteId] && state.entities[websiteId].clearCacheStats ? state.entities[websiteId].clearCacheStats : null
);

export const getWebsiteBoosterBenchmark = (websiteId: number) => createSelector(getBoosterState,
  (state: IBoosterState): IBoosterBenchmark =>
    state.entities[websiteId] && state.entities[websiteId].benchmark ? state.entities[websiteId].benchmark : null
);
